module.exports = __webpack_public_path__ + "media/images/emblems/Illnau-Effretikon-blazon-eb8115749a838ee0f64892cdd45ac9e3.svg";